// ============================================================================
// What the page says when the bridge does not answer with the board (item
// 701). Pure, so the tests beside it can read the exact sentences.
// ============================================================================

/**
 * The bridge's answer, turned into the sentence the page shows. `view` says
 * which read failed: the key can be allowed the items and refused the bots'
 * runs (it was, on 2026-10-06), and "can't reach the board" would then be wrong.
 */
export function bridgeErrorWords(
  status: number,
  body: { error?: string; detail?: string } | null,
  view: 'items' | 'runs' | 'demos' | 'demo' = 'items',
): string {
  const e = body?.error ?? '';
  if (e === 'bridge key missing') return "The bridge can't reach the board: its key is missing.";
  if (e === 'demo shelf unreadable') return "The bridge can't open the demo shelf.";
  if (e === 'bridge key refused' && (view === 'demos' || view === 'demo')) {
    return "The bridge can't read the demo shelf: GitHub refused its key for the bots' downloads.";
  }
  if (e === 'bridge key refused') {
    return view === 'runs'
      ? "The bridge can't read what the bots are running: GitHub refused its key for the bots' run history."
      : "The bridge can't reach the board: GitHub refused its key.";
  }
  if (e === 'github rate limit reached') {
    return "The bridge can't reach the board right now: GitHub's hourly allowance is used up. Try again in a few minutes.";
  }
  if (e === 'board read incomplete') {
    return `The board could not be read in full, so nothing is shown rather than part of it. ${body?.detail ?? ''}`.trim();
  }
  if (status === 401) return 'Your sign-in has run out. Reload the page to sign in again.';
  if (status === 403) return 'The command center is for superusers only.';
  if (e === 'github unreachable') return `The bridge could not reach GitHub. ${body?.detail ?? ''}`.trim();
  return `The bridge answered with an error (${status}${e ? `: ${e}` : ''}).`;
}
